<div class="relative">
  <ng-container *ngIf="field.config.compareToField && field.config.picklistOptions">
    <div class="flex gap-2 mt-1 mb-1">
      <button *ngFor="let opt of field.config.picklistOptions"
              type="button"
              class="btn btn-primary-outline py-1 px-2"
              (click)="onPicklistChange(opt.value)">
        {{ opt.label }}
      </button>
    </div>
  </ng-container>

  <input type="datetime-local"
         [formControl]="control"
         [ngClass]="{'input-error': control.invalid }"
         placeholder="{{field.config.placeholder}}"
         [attr.data-field]="field?.fieldUuid"
         [attr.data-typeId]="field?.config?.typeId"
         [attr.tabIndex]="0"
         [min]="minDate"
  >
</div>
